import React , {useState} from "react";
import { useDispatch  , useSelector} from 'react-redux';

import {useUser } from '../../state/reactquery';
import { modifyDisplaymodal , modifyChampsLeadactu , getAllClients } from '../../state/redux';
import { queryClient } from '../../state/queryClient';
import { addEltHistory } from "../../state/reactquery";

import { dateconvert , convertdatesignature} from "../../utils/utils_dates";

import { axios_clients_updateclients } from "../../axios/axios_clients";
import { axios_contrats_updatecontrat } from "../../axios/axios_contrats";
import { axios_gestion_alertcontratchangestatut } from "../../axios/axios_gestion";

import ButtonSimple from "../Buttons/ButtonSimple";
import FormulaireContrat from "./FormulaireContrat";

import { jsonstatutscontrats } from "../../utils/utils_contratwin";

import croixclose from '../../images/croixclose.svg';

import './ModifContrat.scss' ;
 
function ModifContrat(){
   const dispatch = useDispatch() ;
   const {data: user} = useUser(localStorage.getItem('token'))  ;

   const {date1,date2} = useSelector(state=>state.gestioncontrats);

   const {leadactu } =  useSelector(state=>state.lead);
   const contratchange = useSelector(state=>state.contratchange.value)  ;
   const clients = useSelector(state=>state.datagestion.clients) ;

   const [datacontrat, setDatacontrat] = useState({...contratchange,"nom_titulaire":contratchange.nom_titulaire||leadactu.nom,
                                                    "prenom_titulaire":contratchange.prenom_titulaire||leadactu.prenom,
                                                     "date_effet": dateconvert(contratchange.date_effet), 
                                                     "date_signature" : convertdatesignature(contratchange.date_signature) , 
                                                     "date_fincontrat" : convertdatesignature(contratchange.date_fincontrat)  });
 
   const modifiercontrat = async() =>{
            contratchange.etat_contrat!==datacontrat.etat_contrat && addEltHistory(datacontrat.id_lead,'leadgagne', `<div class='horoline1' > <span className=horobold'>Lead passé en Gagné ${jsonstatutscontrats[datacontrat.etat_contrat]}. </span> </div>` ) ; 

            let newdatacontrat ={...datacontrat} ;
            datacontrat.date_effet &&  (newdatacontrat['date_effet'] = (new Date(datacontrat.date_effet)).toLocaleDateString('fr-FR')) ;
            
            await axios_contrats_updatecontrat(newdatacontrat) ;
            if(datacontrat.etat_contrat !== contratchange.etat_contrat){ 
                        const newlead = {...leadactu,  statut_client: 'gagne_'+datacontrat.etat_contrat ,  date_effet:(new Date(datacontrat.date_effet)).toLocaleDateString('fr-FR')  } ;
                        const otherleads = clients.filter(x=>x.id!==leadactu.id) ;
                        dispatch(modifyChampsLeadactu({statut_client:'gagne_'+datacontrat.etat_contrat}));                                                       
                        axios_clients_updateclients({...newlead});
                        dispatch(getAllClients([...otherleads, newlead]));
                        contratchange?.etat_contrat!==datacontrat?.etat_contrat && axios_gestion_alertcontratchangestatut(newlead,user['nom']) ;  
                       }
                    queryClient.invalidateQueries({ queryKey: ['contrats',leadactu?.email,leadactu?.courtier]}) ;
                    queryClient.invalidateQueries({queryKey: ['allcontrats',date1, date2]}) ;
                      
                        dispatch(modifyDisplaymodal(null));
            }




    return(<div className="containergray"  >
                <div  className="modifcontrat" >
                    <div className="modifcontratclose" ><img src={croixclose}  alt="imgclose" onClick={()=>{dispatch(modifyDisplaymodal(null))}}  />       </div>
                    <div className="modifcontrat_titre" >Modification de contrat</div>
                    <div className="modifcontrat_sstitre" >Contrat signé par : {datacontrat.commercial?.toUpperCase()}</div>

                    <FormulaireContrat datacontrat={datacontrat} setDatacontrat={setDatacontrat} /> 
                    <br />
                    <ButtonSimple  texte="Enregistrer"  containerbouton='fullbuton'  color='bouton_color_orange' size='bouton_size_normal'   onclick={modifiercontrat}    disable={false}  />
                </div>
            </div>)
}


export default ModifContrat